import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { IEditPublicatieCasatoriePayload, IPublicatieCasatorie, IPublicatieCasatorieForm } from '../publicatii-casatorii.interface';
import { PublicatiiCasatoriiService } from '../publicatii-casatorii.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-edit-publicatie',
    templateUrl: './edit-publicatie.component.html',
    styleUrls: ['./edit-publicatie.component.scss']
})
export class EditPublicatieComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        spouse_1: new FormControl(this.data.spouse_1, [Validators.required]),
        spouse_2: new FormControl(this.data.spouse_2, [Validators.required]),
        marriage_date: new FormControl(this.parseDate(this.data.marriage_date), [Validators.required]),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: IPublicatieCasatorie,
        private dialogRef: MatDialogRef<EditPublicatieComponent>,
        private publicatiiCasatoriiService: PublicatiiCasatoriiService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    parseDate(dateString: string): Date {
        const [day, month, year] = dateString.split('.').map(Number);

        // Create a new Date object (adjust month by subtracting 1 as it's zero-based)
        return new Date(year, month - 1, day);
    }

    formatDate(date: Date): string {
        const day: number = date.getDate();
        const month: number = date.getMonth() + 1; // Months are zero-based, so add 1
        const year: number = date.getFullYear();

        const dayString: string = day < 10 ? '0' + day : day.toString();
        const monthString: string = month < 10 ? '0' + month : month.toString();

        return `${year}-${monthString}-${dayString}`;
    }

    submitForm() {
        this.isLoading = true;

        const { spouse_1, spouse_2, marriage_date } = this.form.value as IPublicatieCasatorieForm;
        const payload: IEditPublicatieCasatoriePayload = {
            spouse_1,
            spouse_2,
            marriage_date: this.formatDate(marriage_date),
        };

        this.publicatiiCasatoriiService
            .updatePublicatie(this.data.id, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
